<template>
  <div class="city-contain">
    <div :class="item.isTop == 1 ? 'city-box city-box-first': 'city-box'" v-for="(item,index) in rankList" :key="index">
      <div class="items-box">
      <div class="city-idx">{{item.cardNo}}</div>
      <div class="right-box">
        <div class="city-name" :style="{width:maxWidth}">{{item.city}}</div>
        <!-- <div class="line-box"> -->
          <!-- <div>11----{{item.mark/markMax}}</div> -->
          <!-- <div class="line" :style="'width:' + (item.mark/markMax)*100 + '%'"></div> -->
        <!-- </div> -->
      </div>
      <div class="mark">{{item.mark}}</div>
      <div class="rank-box" v-if="isAll">
        <img class="up-up icon-jiantou" v-if="item.status == 'add'" src="../../../assets/travelAgency/ic_ss_s.png" />
        <img class="down-down icon-jiantou" v-if="item.status == 'decrease'" src="../../../assets/travelAgency/ic_xj_s.png" />
        <div
          :class="item.status == 'add' ? 'up-up' : 'down-down'"
          v-if="item.status != 'equal'"
        >{{item.number}}</div>
        <div class="equal" v-if="item.status == 'equal'">持平</div>
      </div>
      <div class="rank-box" v-else>
        <img class="up-up icon-jiantou" v-if="item.status == 'add'" src="../../../assets/travelAgency/home-up-red2.png" />
        <img class="down-down icon-jiantou" v-if="item.status == 'decrease'" src="../../../assets/travelAgency/home-down-green2.png" />
        <div
          :class="item.status == 'add' ? 'down-down' : 'up-up'"
          v-if="item.status != 'equal'"
        >{{item.number}}</div>
        <div class="equal" v-if="item.status == 'equal'">持平</div>
      </div>
      <div class="rankcharts-items-box-line">
        <rline></rline>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
    import rline from './line'
    export default {
        name: 'rankCharts',
        props: {
            rankList: {
                type: Array,
                default: () => {
                    return []
                }
            },
            isAll: {
                type: Boolean,
                default: true
            }
        },
        components: {
            rline
        },
        data () {
            return {
                maxWidth: '40px',
                markMax: ''
            };
        },
        updated () {
            let nameArry = [];
            let markArry = [];
            if (this.rankList.length > 0) {
                for (let index = 0; index < this.rankList.length; index++) {
                    nameArry.push(this.rankList[index].city);
                    markArry.push(this.rankList[index].mark);
                }
                var longest = nameArry.sort(function (a, b) {
                    return b.length - a.length;
                })[0];
                var markMax = markArry.sort(function (a, b) {
                    return parseInt(b) - parseInt(a);
                })[0];
                this.markMax = markMax;
                this.maxWidth = longest.length * 18.5 + 'px';
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.city-contain {
  width: 100%;
  height: 100%;

  .city-box {

    height: 38px;
    width: 100%;
    padding: 0 16px;

    .items-box{
      box-sizing: border-box;
      height: 38px;
      // padding-top: 12px;
      // padding-bottom: 14px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      position: relative;

      .rankcharts-items-box-line{
        width: 100%;
        position: absolute !important;
        bottom: 0 !important;
        left: 0;
        right: 0;
        height: 1px;
      }

    }
    .city-idx {
      width: 30px;
      font-size: 14px;
      font-family: DIN-Bold, DIN;
      font-weight: bold;
      color:rgba(51,51,51,1);
    }
    .right-box {
      margin-left: 12px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      width: 100%;
      box-sizing: border-box;
      // padding-bottom: 2px;

      .city-name {
        width: 100%;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 10px;
        white-space: nowrap;
        // margin-bottom: 8px;
      }
      // .line-box {
      //   width: 100%;
      //   display: flex;
      //   align-items: center;
      //   justify-content: flex-start;
      //   width: 100%;
      //   .line {
      //     height: 6px;
      //     background: #36b374;
      //   }
      // }
    }
    .mark {
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 10px;
      margin-left: 12px;
      white-space: nowrap;
    }
    .rank-box {
      width: 60px;
      margin-left: 36px;
      // margin-right: 4px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 10px;
      .up-up {
        font-size: 10px;
        font-weight: 400;
        color: rgba(54, 179, 116, 1);
        margin-right: 4px;
      }
      .down-down {
        font-size: 10px;
        font-weight: 400;
        color: rgba(255, 77, 77, 1);
        margin-right: 4px;
      }
      .icon-jiantou {
        width: 8px;
        // margin-top: -4px;
        margin-right: 4px;
      }
      .equal {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 131, 230, 1);
        line-height: 10px;
      }
    }
  }
  .city-box-first{
    background:rgba(54,179,116,0.2);
    box-shadow:0px 0px 0px 0px rgba(238,238,238,1);

    .items-box{
      border-bottom: none;

      .city-idx{
        color:rgba(54,179,116,1);
      }
    }
  }
}

</style>
